'use client';

import { CssBaseline, ThemeProvider } from '@mui/material';
import GlobalStyles from '@mui/material/GlobalStyles';
import { theme } from '@/app/style';
export default function ThemeRegistry({
  children
}) {
  return <ThemeProvider theme={theme}>
      <GlobalStyles styles={{
      '.firebase-emulator-warning': {
        display: 'none'
      }
    }} />

      <CssBaseline />
      {children}
    </ThemeProvider>;
}